import warning from 'warning';
import zIndexDefault from '@/uptk/core/packages/theme/z_index';
import {
  createAction,
  createColorPalette,
  createContainer,
  createDisabled,
  createEditable,
  createFocusable,
  createIconography,
  createOverlayable,
  createSelectable,
  createSize,
  createSpacing,
  createStatus,
  createTypographyNext
} from '@/uptk/core/packages/style/index';

let hasWarnedAboutNextDensity = false;
let hasWarnedAboutNextTheme = false;

const createToolkitThemeNext = (options: any) => {
  const {
    action,
    container,
    disabled,
    editable,
    focusable,
    iconography,
    overlayable,
    palette,
    selectable,
    size,
    spacing,
    status,
    typography,
    zIndex = zIndexDefault,
    ...otherOptions
  } = options;

  const colorPalette = createColorPalette(palette);
  const palettes = {
    iconography: createIconography(colorPalette, iconography),
    palette: colorPalette,
    typography: createTypographyNext(colorPalette, typography)
  };

  const toolkitTheme = {
    useNextTheme: false,
    useNextDensity: false,
    ...otherOptions,
    action: createAction(palettes, action),
    container: createContainer(colorPalette, container),
    disabled: createDisabled(colorPalette, disabled),
    editable: createEditable(colorPalette, editable),
    focusable: createFocusable(colorPalette, focusable),
    overlayable: createOverlayable(zIndex, overlayable),
    size: createSize(size),
    selectable: createSelectable(palettes, selectable),
    spacing: createSpacing(spacing),
    status: createStatus(colorPalette, status),
    ...palettes
  };

  if (import.meta.env.DEV) {
    if (!hasWarnedAboutNextTheme && toolkitTheme.useNextTheme) {
      warning(
          false,
          'UI-Toolkit: useNextTheme is not stable and not supported in Production'
      );
      hasWarnedAboutNextTheme = true;
    }


    if (!hasWarnedAboutNextDensity && toolkitTheme.useNextDensity) {
      warning(
          false,
          'UI-Toolkit: useNextDensity is not stable and not supported in Production'
      );
      hasWarnedAboutNextDensity = true;
    }
  }
  return toolkitTheme;
};

export default createToolkitThemeNext;
